<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-21 10:26:30
 -->
<!--  -->
<template>
<basicContainer>
<div class="announcementManage">
  <!-- 主数据表 -->
  <easyCruds ref="mainTable" :tableInfo="mainTable" @mainTableReload="mainTableReload"
   @addRow="addRow"
   @editRow="editRow"
   @deleteRows="deleteRows">
  </easyCruds>

</div>
</basicContainer>
</template>

<script>
export default {
  data() {
    return {
        mainTable: {
                buttonSetting: {
                    allowAdd: true,
                    allowEdit: true,
                    allowDelete: true,
                    deleteFunctionName: 'deleteRows',
                    allowView: true,
                    addButtonArray: [{
                        clickEvent: 'addRow',
                        buttonName: '新增',
                        type: 'primary',
                        loading: false,
                        validate: false
                    }],
                    editButtonArray: [{
                        clickEvent: 'editRow',
                        buttonName: '保存',
                        type: 'primary',
                        loading: false,
                        validate: false
                    }]
                },
                header: {
                    title: '栏目管理'
                },
                table: {
                    loading: false,
                    height: 550,
                    stripe: true,
                    conditionLabelWidth: '',
                    selection: true,
                    index: false,
                    columns: [{
                        prop: 'name',
                        label: '栏目名称',
                        isSearchCondition: false,
                        type: 'input',
                        span: 12,
                        required: true
                    }, {
                        prop: 'status',
                        label: '状态',
                        isTag: true,
                        isSearchCondition: false,
                        type: 'select',
                        width: 130,
                        dicData: [{
                            label: '启用',
                            value: '1'
                        }, {
                            label: '未启用',
                            value: '0'
                        }],
                        tagFilter: function (e) {
                            if (e === '1') {
                                return {
                                    data: '启用',
                                    type: 'primary'
                                }
                            } else if (e === '0') {
                                return {
                                    data: '未启用',
                                    type: 'warning'
                                }
                            } else {
                                return {
                                    data: '未知状态',
                                    type: 'danger'
                                }
                            }
                        },
                        required: true,
                    }, {
                        prop: 'createTime',
                        label: '创建时间',
                        width: 170,
                        view: [false, false, false]
                    }, {
                        prop: 'createUserName',
                        label: '创建人',
                        width: 150,
                        view: [false, false, false]
                    }],
                    operation: {
                        width: '220',

                    },
                    tableData: [],
                    paging: {
                        currentPage: 1,
                        pageSizes: [10, 15, 20, 25],
                        pageSize: 10,
                        total: 0
                    },
                    reload: 'mainTableReload',
                    reloadConditions: {},
                    addDefultValue: {
                        receiverType: '1',
                        user: [],
                        role: [],
                        organ: []
                    }
                }

            }
    }
  },

  mounted() {
    this.mainTableReload({ pageNum: 1, pageSize: 10 })
  },
  methods: {
    mainTableReload: function(params) {
      this.mainTable.table.loading = true
      this.$http.post('/base/noticeNew/type/query',  {
          "entity": {
              "id": "",
              "code": "",
              "name": "",
              "status": "",
              "createUserName": "",
              "createTime": "",
              "updateUserName": "",
              "updateTime": "",
              "zhid": ""
          },
          "orderItemList": [
              {
                  "asc": true,
                  "column": ""
              }
          ]
      },{
            params
        }).then(
        response => {
          this.mainTable.table.loading = false
          // 成功之后的数据
          this.mainTable.table.tableData = response.data.records
          this.mainTable.table.paging.total = response.data.total || response.data.records.length
          return true
        }
      ).catch(
        error => {
          this.mainTable.table.loading = false
          this.$message.error(error.msg)
        }
      )
    },
    addRow: function(row, done, errorDone, optionType, issued) {
        this.$http.post('/base/noticeNew/type/save', row).then(response => {
            this.$message.success('新增成功') && done()
            this.mainTableReload(this.$refs.mainTable.getReloadConditions())
        }).catch(error => {
            this.$message.error(error.msg) && errorDone()
        })
    },
    editRow: function(row, done, errorDone, optionType) {
        this.$http.post('/base/noticeNew/type/update', row).then(response => {
            this.$message.success('更新成功') && done()
            this.mainTableReload(this.$refs.mainTable.getReloadConditions())
        }).catch(error => {
            this.$message.error(error.msg) && errorDone()
        })
    },
    deleteRows: function(deleteList) {
      this.$http.delete('/base/noticeNew/type/delete', {
        params: {
          idList: deleteList.map(item => item.id)
        }
      }).then(response => {
        this.$message.success('删除成功')
        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },

  }
}
</script>

<style lang='scss'>

   .quill-editor {
      height: 300px;
    }

</style>
<style lang='scss' scoped>

</style>
